export enum Language {
    EN = 'en',
    ES = 'es',
}

export enum CountryCodes {
    UK = 'GB',
    SPAIN = 'ES',
}
